import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

/**
 * Detecta respuestas 401 de autenticación (token vencido o sesión cerrada en
 * otro dispositivo) y cierra la sesión de forma centralizada, una única vez.
 *
 * NO desloguea ante errores transitorios (500, timeout, red): eso lo maneja
 * cada servicio sin expulsar al usuario. Tampoco interrumpe el login.
 *
 * Se resuelve AuthService de forma perezosa con Injector: AuthService depende
 * de HttpClient, y un interceptor que lo inyecte en el constructor generaría
 * una dependencia circular.
 */
@Injectable()
export class AuthSessionInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error) => {
                const esLogin = req.url.includes('/auth/login');
                const esAuth = error instanceof HttpErrorResponse && error.status === 401;

                if (esAuth && !esLogin) {
                    const auth = this.injector.get(AuthService);
                    if (auth.hasToken()) {
                        auth.handleAuthFailure(auth.codigoDeError(error));
                    }
                }

                return throwError(error);
            }),
        );
    }
}
